import React, { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  children: React.ReactNode;
  icon?: JSX.Element;
}

const ServiceButton = ({ className, children, ...props }: ButtonProps) => {
  const dataContext = useContext(AuthContext);

  if (!dataContext) return null;
  const { theme } = dataContext;
  return (
    <div className={`${theme === 'dark' ? "bg-white" : "card-gradient"} p-[1px] w-fit rounded-full transition-all duration-500`}>
      <button
        className={`${theme === 'dark' ? "bg-primary" : "bg-[#0F0F0F]"} font-gtAmerica leading-none flex items-center gap-2 px-3 sm:px-8 py-3 sm:py-4 text-[16px] font-medium rounded-full transition-all duration-500 hover:card-gradient ${
          className ? className : ""
        }`}
        {...props}
      >
        {children}
      </button>
    </div>
  );
};

export default ServiceButton;
